import React, { useEffect, useState } from "react";
import customers from "../Assets/dashcard/users.svg";
import rider from "../Assets/dashcard/drivers.svg";
import complete from "../Assets/dashcard/complete.png";
import cancel from "../Assets/dashcard/cancel.jpg";
import ridesimages from "../Assets/dashcard/ridesimage.png";
import down from "../Assets/dashcard/downgraph.svg";
import up from "../Assets/dashcard/upgraph.svg";
import { useSelector } from "react-redux";
import "../Style/Component/Dashcard.css";
import { getWithTokenAPI } from "../Util/Api";
import { useNavigate } from "react-router-dom";
import { DashboardSkeleton, Locationcard } from "./Skeleton";

const Dashcard = ({ page, city, district }) => {
  const auth = useSelector((state) => state.auth);
  const token = auth.token;
  const [count, setCount] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) return;

    const fetchtablevalues = async () => {
      setLoading(true);

      const apiendpoint =
        page === "home"
          ? !city && !district
            ? `/rides`
            : `/rides?district=${district || ""}&city=${city || ""}`
          : `/admin/city/list-all?page=1&limit=10&all=true`;

      try {
        const res = await getWithTokenAPI(token, apiendpoint);
        setCount(res?.data);
      } catch (error) {
        console.log("Error in fetching Api", error);
      } finally {
        setLoading(false); 
      }
    };

    fetchtablevalues();
  }, [token, page, city, district]);

  const formatNumber = (num) => new Intl.NumberFormat("en-IN").format(num || 0);

  const formatINR = (amount) =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(amount || 0);

  const pcardlist = [
    {
      icon: customers,
      title: "Total Customers",
      count: formatNumber(count?.totalCustomers?.count),
      graph: count?.totalCustomers?.change,
      navigate: "/admin/customer",
    },
    {
      icon: rider,
      title: "Total Drivers",
      count: formatNumber(count?.totalDrivers?.count),
      graph: count?.totalDrivers?.change,
      navigate: "/admin/drivers",
    },
    {
      icon: rider,
      title: "Active Rides",
      count: formatNumber(count?.activeRides?.count),
      graph: count?.activeRides?.change,
      navigate: "/admin/rides",
    },
  ];

  const icardlist = [
    {
      icon: complete,
      title: "Completed Rides",
      count: formatNumber(count?.completedRides?.count),
    },
    {
      icon: cancel,
      title: "Cancelled Rides",
      count: formatNumber(count?.cancelledRides?.count),
    },
    {
      icon: ridesimages,
      title: "Ride Revenue",
      count: formatINR(count?.revenue?.total),
    },
  ];

  const icardlistloc = [
    {
      icon: complete,
      title: "Active Cities",
      count: formatNumber(count?.activeCities),
    },
    {
      icon: cancel,
      title: "Inactive Cities",
      count: formatNumber(count?.inactiveCities),
    },
    {
      icon: cancel,
      title: "Total Cities",
      count: formatNumber(count?.totalCities),
    },
  ];

  return (
    <div className="dashcard">
      {page === "home" ? (
        loading ? (
          <>
            {/* ✅ Show two skeleton sections */}
            <DashboardSkeleton />
          </>
        ) : (
          <>
            {/* Primary Cards */}
            <div className="dashcardplain">
              {pcardlist.map((item, index) => (
                <div
                  key={index}
                  className="pcard"
                  onClick={() => {
                    const params = new URLSearchParams();
                    if (district) params.append("district", district);
                    if (city) params.append("city", city);
                    const queryString = params.toString();
                    navigate(
                      `${item.navigate}${queryString ? `?${queryString}` : ""}`
                    );
                  }}
                >
                  <div className={`leftpcard ${index === 0 ? "first" : ""}`}>
                    <div className="forimageicon">
                      <img src={item.icon} alt={item.title} />
                    </div>
                  </div>

                  <div className={`rightpcard ${index === 0 ? "first" : ""}`}>
                    <span style={{ fontWeight: 450, fontSize: "24px" }}>
                      {item.title}
                    </span>

                    <span
                      style={{
                        fontWeight: 400,
                        fontSize: "28px",
                        marginBottom: "7px",
                      }}
                    >
                      {item.count}
                    </span>

                    <img
                      src={item?.graph?.includes("Up") ? up : down}
                      className="graphsign"
                      alt="graph"
                    />
                    <span style={{ fontSize: "13px" }}>{item.graph}</span>
                  </div>
                </div>
              ))}
            </div>

            {/* Secondary Cards */}
            <div className="dashcardimage">
              {icardlist.map((item, index) => (
                <div key={index} className="icard">
                  <img src={item.icon} alt={item.title} />
                  <div>
                    <span>{item.title}</span>
                    <span>{item.count}</span>
                  </div>
                </div>
              ))}
            </div>
          </>
        )
      ) : loading ? (
        <Locationcard />
      ) : (
        <div className="dashcardimage">
          {icardlistloc.map((item, index) => (
            <div key={index} className="icard">
              <img src={item.icon} alt={item.title} />
              <div>
                <span>{item.title}</span>
                <span>{item.count}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Dashcard;
